<template>
    <div>
        <el-dialog
            width="35%"
            top="5%"
            title="转快递"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :before-close="handleClose"
            class="expressDialog"
            v-dialogDrag
        >
            <div class="log-dialog-table">
                <el-form
                    :model="logisticsInfoForm"
                    :rules="rules"
                    ref="form"
                    label-width="120px"
                >
                    <el-row>
                        <el-col :span="18">
                            <el-form-item label="物流公司：" prop="logisticsCompanyName">
                                <el-input
                                    v-model="logisticsInfoForm.logisticsCompanyName"
                                    :readonly="true"
                                    autocomplete="off"
                                    placeholder="物流公司名称"
                                >
                                    <i
                                        slot="suffix"
                                        class="el-input__icon el-icon-circle-close"
                                        v-if="logisticsInfoForm.logisticsCompanyName"
                                        @click="clearLogisticsCompanyInfo"
                                    ></i>
                                    <el-button
                                        slot="append"
                                        icon="el-icon-search"
                                        @click="openAdvanceDialog"
                                    ></el-button>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="18">
                            <el-form-item label="物流单号：" prop="expressNo">
                                <el-input
                                    v-model="logisticsInfoForm.expressNo"
                                    autocomplete="off"
                                    placeholder="请输入物流单号"
                                    clearable
                                    maxlength="32"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="expressType === '1'">
                        <el-col :span="18">
                            <el-form-item label="手机号后四位：" prop="mobile">
                                <el-input
                                    autocomplete="off"
                                    @input="clearValidate"
                                    v-model="logisticsInfoForm.mobile"
                                    placeholder="请输入发件人或收件人手机号后四位"
                                    maxlength="4"
                                    clearable
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <el-divider></el-divider>

                <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    v-loading="loading"
                    resizable="true"
                    show-overflow-tooltip="true"
                    height="240"
                >
                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="logisticsCompanyName" label="物流公司" width="150" align="center"></el-table-column>
                    <el-table-column prop="expressNo" label="物流单号" align="center"></el-table-column>
                    <el-table-column prop="waybillNo" label="安得运单号" align="center"></el-table-column>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button @click="viewRoute" :disabled="this.tableData.length === 0" :loading="loadingRouter">查看路由</el-button>
                <el-button type="primary" @click="handleSave" :loading="loadingBtn">保 存</el-button>
            </span>

            <advanceDialog
                ref="advanceDialog"
                v-model="logisticsInfoForm.logisticsCompanyName"
                :mValue="logisticsInfoForm.logisticsCompanyName"
                :params="config.logisticsCompanyConfig"
                @confirm="confirm"
            ></advanceDialog>

        </el-dialog>

    </div>
</template>
<script>
import config from './config.js';
import envConfig from '@/config/user.env';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import { logisticsExpressQuery, expressSave, viewRouteApi } from '../../../../../api/transferSystem.js';
export default {
    name: 'expressDialog',
    components: { advanceDialog },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        // 校验 手机号后四位 格式
        var validateDriverPass = (rule, value, callback) => {
            const _phoneVerify = /^[0-9]{4}$/;
            if (!value) {
                callback(new Error('请输入发件人或收件人手机号后四位'));
            } else if (!_phoneVerify.test(value)) {
                callback(new Error('请输入正确的手机号后四位'));
            } else {
                callback();
            }
        };
        return {
            config,
            tableData: [],
            expressType: null, // 快递公司类型
            loading: false,
            loadingBtn: false,
            loadingRouter: false,
            logisticsInfoForm: {
                logisticsCompanyName: '',
                logisticsCompanyCode: '',
                expressNo: '',
                mobile: '',
                required: true
            },
            rules:{
                logisticsCompanyName: [{ required: true, message: '请选择物流公司', trigger: ['change', 'blur'] }],
                expressNo: [{ required: true, message: '请输入物流单号', trigger: ['change', 'blur'] }],
                mobile: [{ validator: validateDriverPass, required: true, trigger: ['change', 'blur'] }]
            }
        };
    },
    mounted () {
        this.getListData();
    },
    methods: {
        // 获取列表数据
        getListData () {
            const params = this.rowData.customerOrderNo || '';
            logisticsExpressQuery(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = res.data || [];
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                })
        },
        clearValidate () {
            this.$refs.form.clearValidate(); // 移除表单项的校验结果
            this.logisticsInfoForm.mobile = (this.logisticsInfoForm.mobile + '').replace(/[^\d]+$/g, '');
        },
        // 打开物流公司高级搜索 弹窗
        openAdvanceDialog () {
            this.$refs.advanceDialog.show(true, this.config.logisticsCompanyConfig, { logisticsCompanyName: this.logisticsInfoForm.logisticsCompanyName }, '', [], this.logisticsInfoForm.logisticsCompanyName);
        },
        // 物流公司高级搜索 数据选中的回调
        confirm (data) {
            this.logisticsInfoForm.logisticsCompanyName = data.logisticsCompanyName;
            this.logisticsInfoForm.logisticsCompanyCode = data.logisticsCompanyCode;
            this.expressType = data.expressType;
            if (this.expressType !== '1') {
                this.logisticsInfoForm.mobile = '';
            }
        },
        // 物流公司搜索框 清空的方法
        clearLogisticsCompanyInfo () {
            this.logisticsInfoForm.logisticsCompanyName = '',
            this.logisticsInfoForm.logisticsCompanyCode = ''
        },
        // 取消按钮
        handleClose () {
            this.$emit('handleClose', 'expressDialog');
        },
        // 查看路由
        viewRoute () {
            const customerOrderNo = this.rowData.customerOrderNo || '';
            const taskNo = this.rowData.taskNo || '';
            const url = location.origin;
            this.loadingRouter = true;
            viewRouteApi(customerOrderNo, taskNo)
                .then(res => {
                    if (res && +res.code === 0) {
                        if (envConfig.env === 'PROD') {
                            this.rowData.customerOrderNo && window.open(`https://www.annto.com/order/?orderNoFormMain=${this.rowData.customerOrderNo}`);
                        } else if (envConfig.env === 'VER') {
                            this.rowData.customerOrderNo && window.open(`https://www-ver.annto.com/order/?orderNoFormMain=${this.rowData.customerOrderNo}`);
                        } else {
                            this.rowData.customerOrderNo && window.open(`https://www-uat.annto.com/order/?orderNoFormMain=${this.rowData.customerOrderNo}`);
                        }
                    }
                })
                .catch(() =>{ })
                .finally(() => {
                    this.loadingRouter = false;
                });
        },
        // 保存按钮
        handleSave () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const params = {
                        taskNo: this.rowData.taskNo,
                        customerOrderNo: this.rowData.customerOrderNo,
                        ...this.logisticsInfoForm
                    }
                    this.loadingBtn = true;
                    expressSave(params)
                        .then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('保存成功');
                            }
                        })
                        .catch(() => { })
                        .finally(() => {
                            this.$nextTick(() => {
                                this.loadingBtn = false;
                                this.getListData();
                            })
                        })
                }
            })
        }
    }
};
</script>
<style lang="less" scoped>
.expressDialog {
    .import {
        position: absolute;
        top: 16px;
        right: 55px;
        padding: 0;
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 20px;
    }
    .log-dialog-table {
        min-height: 200px;
        max-height: 500px;
        overflow: auto;
    }
    .el-dialog__body {
        margin: 15px 15px 0 15px;
    }
    .el-table {
        margin-bottom: 35px;
        min-height: 150px;
    }
    .el-divider--horizontal {
        margin: 5px 0 24px;
    }
    .el-pagination,
    .el-button {
        font-weight: normal;
        text-align: right;
    }
    .el-pagination {
        text-align: center;
    }
    .el-pagination .el-select .el-input {
        width: 70px;
    }
}
</style>
